<template>
  <div class="page-index flex">
    <el-carousel class="banner-carousel" indicator-position="outside">
      <el-carousel-item v-for="item in bannerList" :key="item.url">
        <img class="car-img" :src="item.url" alt="" />
      </el-carousel-item>
    </el-carousel>
    <div class="container">
      <div class="header flex flex-main-justify flex-cross-center">
        <div class="title">
          <div class="title-text">Dashboard for Ultrafast Charging Stations</div>
          <img src="../assets/img/Mekanika Logo.png" class="tvc" alt="">
        </div>
      </div>
      <div class="car-list">
        <!-- <div class="charge-blank" v-if="chargingList.length === 0"> -->
        <div class="charge-blank" v-if="!isChargingCarList.length">
          <span class="charge-text">Parking for charging</span>
          <div class="charge-car"></div>
        </div>
        <div class="charge-ing" v-else>
          <!-- 充电车轮播图 -->
          <el-carousel
            indicator-position="outside"
            class="car-charge"
            :interval="10000"
          >
            <!-- chargingList -->
            <el-carousel-item
              v-for="item in isChargingCarList"
              :key="item.gunThirdDeviceId"
              class="carousel-page"
            >
              <!-- 准备中 -->
              <div
                v-if="gunStatusObj[item.gunThirdDeviceId] == 3"
                class="flex flex-dir-top flex-cross-center flex-main-center parking-car-box"
              >
                <span class="charge-text">Preparing</span>
                <img
                  src="../assets/img/car.png"
                  class="parking-car-img"
                  alt=""
                />
              </div>
              <!-- 已完成 -->
              <div
                v-else-if="gunStatusObj[item.gunThirdDeviceId] == 6"
                class="flex flex-dir-top flex-cross-center flex-main-center parking-car-box"
              >
                <span class="charge-text">Completed</span>
                <img
                  src="../assets/img/car.png"
                  class="parking-car-img"
                  alt=""
                />
              </div>
              <div
                v-else
                class="charge-show flex flex-main-center flex-cross-center"
              >
                <div class="SOC">
                  <p class="charge-gun-name tac">
                    {{ item.pileCode + "-" + item.gunName }}
                  </p>
                  <div class="soc-top">
                    <div class="car-logo">
                      <div class="logo-img"></div>
                      <span class="soc-title">SOC</span>
                    </div>
                  </div>
                  <div class="soc-center">
                    <div class="Power-percentage">
                      {{ (+item.VehicleBatteryPercentage).toFixed(2) }}%
                    </div>
                    <div class="Power-num">
                      {{ (+item.Power).toFixed(2) }}KW
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="charge-list">
          <div class="charge-logo">
            <div class="logo-img"></div>
            <div class="logo-text">Status</div>
          </div>
          <div class="charge-table">
            <el-table
              :data="bsChargeGunList"
              class="charge-gun-list"
              style="width: 100%"
              :header-cell-style="{
                color: '#000',
                fontSize: '14px'
              }"
              :span-method="objectSpanMethod"
              :cell-style="cellStyle"
            >
              <el-table-column
                prop="pileCode"
                label="Charger"
              ></el-table-column>
              <el-table-column
                prop="gunName"
                label="Connector"
                width="120"
              ></el-table-column>
              <el-table-column prop="gunState" label="Status">
                <template slot-scope="scope">
                  <span
                    :class="
                      chargeStatusColorValueObj[scope.row.gunThirdDeviceId]
                    "
                  >
                    {{
                      gunStatusTextObj[gunStatusObj[scope.row.gunThirdDeviceId]]
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="StartTime" label="Start Time">
                <template slot-scope="scope">
                  <span>{{
                    judgeDataShow(scope.row, "StartTime")
                      ? $dayjs(scope.row.StartTime).format("HH:mm:ss")
                      : "--"
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="EndTime" label="End Time">
                <template slot-scope="scope">
                  {{
                    judgeDataShow(scope.row, "EndTime")
                      ? $dayjs(scope.row.EndTime).format("HH:mm:ss")
                      : "--"
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="duration" label="Time(Min)" width="90">
                <template slot-scope="scope">
                  {{
                    judgeDataShow(scope.row, "duration")
                      ? parseInt(scope.row.duration / 60) +
                        "'" +
                        (scope.row.duration % 60) +
                        '"'
                      : "--"
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="Power" label="Avg Power(kW)" width="90">
                <template slot-scope="scope">
                  {{
                    judgeDataShow(scope.row, "avgPower")
                      ? formatFloat(scope.row.avgPower, 1) + "kW"
                      : "--"
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="Energy" label="Capacity(kWh)" width="80">
                <template slot-scope="scope">
                  {{
                    judgeDataShow(scope.row, "Energy")
                      ? formatFloat(scope.row.Energy, 1) + "kWh"
                      : "--"
                  }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SockJs from "sockjs-client";
import Stomp from "stompjs";
export default {
  data() {
    return {
      frequency: 60,
      bannerList: [],
      statusObj: {
        available: "available", // 可用
        occupied: "occupied", // 占用
        preparing: "preparing", // 准备中
        charging: "charging", // 充电中
        suspended_evse: "suspended_evse", // 挂起-充电设备
        suspended_ev: "suspended_ev", // 挂起-电动车辆
        finishing: "finishing", // 结束中
        reserved: "reserved", // 预留
        unavailable: "unavailable", // 不可用
        faulted: "faulted", // 故障
        closed: "closed" // 关闭
      },
      eventStatusObj: {
        template: "template", // 模板
        ready: "ready", // 准备就绪
        in_progress: "in_progress", // 进行中
        refused: "refused", // 拒绝
        limit_reached: "limit_reached", // 达到限制
        closed: "closed", // 已关闭
        stale: "stale", // 过时
        rating_failed: "rating_failed", // 评估失败
        billing_failed: "billing_failed", // 计费失败
        closing: "closing", // 正在关闭
        reserved: "reserved" // 已预留
      },
      isDouble: false,
      paramObj: {
        10: "DC1_Power",
        20: "PV_Power",
        site: "Active_Power_total"
      },
      PowerDataObj: {
        DC1_Power: 0,
        DC2_Power: 0,
        PV_Power: 0,
        Active_Power_total: 0,
        batteryPercent: 0,
        pvPercent: 0,
        netPercent: 0,
        total: 0
      },
      percentObj: {},
      PowerObj: {},
      list: ["text2"],
      weekObj: {
        0: "星期日",
        1: "星期一",
        2: "星期二",
        3: "星期三",
        4: "星期四",
        5: "星期五",
        6: "星期六"
      },
      chargeStatus: [
        {
          id: 10,
          value: "充电中"
        },
        {
          id: 20,
          value: "放电中"
        },
        {
          id: 30,
          value: "FFR中"
        },
        {
          id: 40,
          value: "已完成"
        },
        {
          id: 50,
          value: "待充电"
        },
        {
          id: 60,
          value: "结束充电"
        },
        {
          id: 70,
          value: "结算中"
        },
        {
          id: 80,
          value: "待支付"
        },
        {
          id: 90,
          value: "其他"
        }
      ],
      timer: null,
      xy: 0,
      heartTimer: null,
      animateTimer: null,
      singleWs: null,
      getRefreshTokenNum: null,
      eventStompClient: null,
      gunStompClient: null,
      refresh: {
        refreshToken: "",
        updateTime: ""
      },
      weather: {},
      eventSocket: "",
      gunSocket: "",
      weatherUrl: "",
      tbDeviceId: "",
      token: "",
      realTime: "",
      selectedSite: "",
      stationEventsList: [],
      bsAssetsList: [],
      chargeGunListList: [],
      bsChargeGunList: [],
      // 充电中的车
      isChargingCarList: [],
      // 车与充电枪数据
      gunAndCarList: [],
      // 有vin值的车
      chargeVinObj: {},
      // 单枪充电的车
      singleGunCarList: [],
      // 双枪充电的车
      doubleGunCarList: [],
      key: "",
      stationNum: [],
      chargingList: [],
      batteryPowerList: [],
      deviceList: [],
      eventList: [],
      chargeStatusColorValueObj: {},
      chargeGunStatusValueObj: {},
      gunStatusObj: {},
      gunStatusTextObj: {
        0: "New",
        1: "Offline",
        2: "Available",
        3: "Preparing",
        4: "Charging",
        5: "Suspended",
        6: "Finishing",
        7: "Reserved",
        99: "Removed"
      },
      currentEventIndex: -1,
      bannerReloadTimer: null,
      gunDataObj: {},
      socketGunData: {},
      socketGunIndex: -1,
      chargingGunIndex: -1
    };
  },
  watch: {
    batteryPowerList(now) {
      console.log(now, "batteryPowerList");
      this.percentObj[now[1].gunThirdDeviceId] =
        this.PowerObj[now[1].gunThirdDeviceId] / now[1].value;
    }
  },
  methods: {
    getBannerList() {
      this.$http
        .get(
          "/xre/sys/oss/screenPicList",
          {},
          {
            hideLoading: true
          }
        )
        .then(res => {
          console.log(res, "banner list");
          this.bannerList = res.data;
        });
    },
    judgeDataShow(item, param) {
      return (
        item[param] && [4, 6].includes(this.gunStatusObj[item.gunThirdDeviceId])
      );
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 更改场站事件列表的状态颜色
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 状态列字体颜色
      if (row.eventStatus === 40 && columnIndex === 3) {
        return "color: #00B6AA";
      } else if (row.eventStatus === 10 && columnIndex === 3) {
        return "color: #EA1B29";
      }
    },
    // 四舍五入小数
    formatFloat(num, n) {
      let f = parseFloat(num);
      if (isNaN(f)) {
        return false;
      }
      f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); // n 幂
      let s = f.toString();
      let rs = s.indexOf(".");
      // 判定如果是整数，增加小数点再补0
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + n) {
        s += "0";
      }
      return s || "0";
    },
    // 设置进度条格式
    format(percentage) {
      return percentage === 100 ? "满" : `${percentage}%`;
    },
    // 获取充电枪订阅
    getSocketGunMessage() {
      this.gunSocket = "";
      this.gunStompClient && this.gunStompClient.disconnect();
      this.gunSocket = new SockJs(
        "/api/xre/websocketServer?token=" + this.token
      );
      this.gunStompClient = Stomp.over(this.gunSocket);
      this.gunStompClient.connect(
        {},
        () => {
          this.gunStompClient.subscribe(
            "/user/" + this.selectedSite + "/allMessage",
            res => {
              this.socketGunData = JSON.parse(res.body);
              console.log(this.socketGunData, "充电枪订阅");
              console.log(
                this.$dayjs(Date.now()).format("HH:mm:ss"),
                "充电枪订阅"
              );
              this.socketGunData.forEach(item => {
                this.$set(
                  this.gunStatusObj,
                  item.gunThirdDeviceId,
                  item.gunState
                );
                if (item.gunState == 2 || item.gunState == 3) {
                  // Available || Preparing
                  // 枪重新准备时，清除掉缓存的上一条充电数据
                  this.socketGunIndex = this.bsChargeGunList.findIndex(ele => {
                    return ele.gunThirdDeviceId == item.gunThirdDeviceId;
                  });
                  this.gunDataObj = this.bsChargeGunList[this.socketGunIndex];
                  this.gunDataObj.StartTime = "";
                  this.gunDataObj.EndTime = "";
                  this.gunDataObj.Power = "";
                  this.gunDataObj.Energy = "";
                  this.gunDataObj.duration = "";
                  this.gunDataObj.avgPower = "";
                  this.$set(
                    this.bsChargeGunList,
                    this.socketGunIndex,
                    this.gunDataObj
                  );
                }
                if (item.gunState == 4 || item.gunState == 6 || item.gunState == 3) {
                  // 充电中 || 完成 || 准备中
                  this.$set(
                    this.gunStatusObj,
                    item.gunThirdDeviceId,
                    item.gunState
                  );
                  console.log(this.gunStatusObj, 'gun status obj');
                  this.socketGunIndex = this.bsChargeGunList.findIndex(ele => {
                    return ele.gunThirdDeviceId == item.gunThirdDeviceId;
                  });
                  this.chargingGunIndex = this.isChargingCarList.findIndex(
                    ele => {
                      return ele.gunThirdDeviceId == item.gunThirdDeviceId;
                    }
                  );
                  this.gunDataObj = {
                    ...this.bsChargeGunList[this.socketGunIndex],
                    ...item.activeChargingSession
                  };
                  this.$set(
                    this.bsChargeGunList,
                    this.socketGunIndex,
                    this.gunDataObj
                  );
                  if (this.chargingGunIndex != -1) {
                    this.gunDataObj = {
                      ...this.isChargingCarList[this.chargingGunIndex],
                      ...item.activeChargingSession
                    };
                    this.$set(
                      this.isChargingCarList,
                      this.chargingGunIndex,
                      this.gunDataObj
                    );
                  } else {
                    this.isChargingCarList.push(this.gunDataObj);
                  }
                } else {
                  // 将车从充电列表移除
                  this.chargingGunIndex = this.isChargingCarList.findIndex(
                    ele => {
                      return ele.gunThirdDeviceId == item.gunThirdDeviceId;
                    }
                  );
                  if (this.chargingGunIndex != -1) {
                    this.isChargingCarList.splice(this.chargingGunIndex, 1);
                  }
                }
              });
            },
            err => {
              console.log(err, "error");
              this.handleEventDisconnect();
            }
          );
        },
        err => {
          console.log(err, "err");
          this.handleEventDisconnect();
        }
      );
      this.gunSocket.onclose = () => {
        this.handleEventDisconnect();
      };
    },
    getSocketEventMessage() {
      this.eventSocket = "";
      this.eventStompClient && this.eventStompClient.disconnect();
      console.log(process.env.NODE_ENV, "env");
      this.eventSocket = new SockJs(
        (process.env.NODE_ENV == "production" ? "/api" : "/api") +
          "/xre/websocketServer?token=" +
          this.token
      );
      this.eventStompClient = Stomp.over(this.eventSocket);
      this.eventStompClient.connect(
        {},
        () => {
          this.eventStompClient.subscribe(
            "/user/" + this.selectedSite + "/eventMessage",
            res => {
              this.eventObj = JSON.parse(res.body);
              console.log(this.eventObj, "事件订阅");
              console.log(
                this.$dayjs(Date.now()).format("HH:mm:ss"),
                "事件订阅"
              );
              // this.chargeEventObj[this.eventObj.gunThirdDeviceId] =
              //   this.eventObj.endChargeReason;
              this.currentEventIndex = this.bsChargeGunList.findIndex(
                item => item.gunThirdDeviceId == this.eventObj.gunThirdDeviceId
              );
              let obj = this.bsChargeGunList[this.currentEventIndex];
              console.log(this.currentEventIndex, "current event index");
              console.log(obj, "current event obj");
              obj.StartTime = this.eventObj.StartTime;
              obj.EndTime = this.eventObj.EndTime;
              obj.Power = this.eventObj.Power;
              obj.Energy = this.eventObj.Energy;
              obj.duration = this.eventObj.duration;
              this.$set(this.bsChargeGunList, this.currentEventIndex, obj);
              let i = this.isChargingCarList.findIndex(item => {
                return item.gunThirdDeviceId == this.eventObj.gunThirdDeviceId;
              });
              let ind = this.bsChargeGunList.findIndex(item => {
                return item.gunThirdDeviceId == this.eventObj.gunThirdDeviceId;
              });
              this.bsChargeGunList[ind] = this.eventObj;
              if (this.eventObj.status == "in_progress") {
                if (i == -1) {
                  this.isChargingCarList.push(this.eventObj);
                } else {
                  this.isChargingCarList[i] = this.eventObj;
                }
              } else {
                this.isChargingCarList.splice(i, 1);
              }
            },
            err => {
              console.log(err, "error");
              this.handleEventDisconnect();
            }
          );
        },
        err => {
          console.log(err, "error");
          this.handleEventDisconnect();
        }
      );
      this.eventSocket.onclose = () => {
        this.handleEventDisconnect();
      };
    },
    // 充电枪事件订阅断开重连
    handleEventDisconnect() {
      this.reConnectEvent && clearTimeout(this.reConnectEvent);
      this.reConnectEvent = setTimeout(() => {
        // this.getSocketEventMessage();
        this.getSocketGunMessage();
      }, 5000);
    },
    heart() {
      this.$http
        .get(
          "/xre/sys/heart",
          {},
          {
            hideLoading: true
          }
        )
        .then(res => {
          console.log(res, "heat");
          if (this.frequency != res.seconds) {
            this.frequency = res.seconds;
            this.bannerReloadTimer && clearInterval(this.bannerReloadTimer);
            this.bannerReloadTimer = setInterval(() => {
              this.getBannerList();
            }, this.frequency * 1000);
          }
          if (res.reloadFlag == "1") {
            this.$http.get("/xre/sys/closeReload").then(res => {
              console.log(res, "closeReload");
            });
            setTimeout(() => {
              location.reload();
            }, 2000);
          }
        })
        .catch(res => {
          console.log(res, "error");
          this.getLoginInfo();
        });
    },
    // 获取登录信息
    getLoginInfo() {
      return this.$http
        .post("/xre/sys/token", {
          username: "malta",
          password: "maltaXre123"
        })
        .then(res => {
          // console.log(res, "登录信息");
          this.token = res.token;
          this.refresh.refreshToken = res.refreshToken;
          this.refresh.updateTime = +res.expire + "000";
          this.$store.commit("updateToken", res.token);
          // this.$store.commit("updateRefreshToken", this.refresh);
          // this.getRefreshTokenNum = setInterval(() => {
          //   this.getRefreshToken();
          // }, this.refresh.updateTime - 1000);
          // console.log(this.refresh.updateTime, "vuex里面的数据");
          this.getBannerList();
          // 每一个小时获取一次新的banner
          this.bannerReloadTimer && clearInterval(this.bannerReloadTimer);
          this.bannerReloadTimer = setInterval(() => {
            this.getBannerList();
          }, this.frequency * 1000);
          this.getCurrentDiagram();
          // this.getGunList();
          this.heartTimer && clearInterval(this.heartTimer);
          this.heartTimer = setInterval(() => {
            this.heart();
          }, 60000);
        });
    },
    // 获取大屏电流图
    getCurrentDiagram() {
      this.$http.get("/xre/bs/sites/diagram").then(res => {
        this.selectedSite = res.data[0].bsSitesId;
        this.bsChargeGunList = res.data[0].bsChargeInfoList;
        this.gunStatusObj = {};
        this.bsChargeGunList.forEach(item => {
          this.$set(this.gunStatusObj, item.gunThirdDeviceId, item.gunState);
        });
        this.bsChargeGunList.forEach(item => {
          if (![4, 6].includes(item.gunState)) {
            item.StartTime = "";
            item.EndTime = "";
            item.Power = "";
            item.Energy = "";
            item.duration = "";
            item.avgPower = "";
          } else {
            item.StartTime = item.activeChargingSession.StartTime;
            item.EndTime = item.activeChargingSession.EndTime;
            item.Power = item.activeChargingSession.Power;
            item.Energy = item.activeChargingSession.Energy;
            item.duration = item.activeChargingSession.duration;
            item.avgPower = item.activeChargingSession.avgPower;
            item.VehicleBatteryPercentage =
              item.activeChargingSession.VehicleBatteryPercentage;
          }
        });
        this.isChargingCarList = this.bsChargeGunList.filter(item =>
          [3, 4, 6].includes(item.gunState)
        );
        // this.getSocketEventMessage();
        this.getSocketGunMessage();
        //      gun status:
        //      New = 0
        //      Offline = 1
        //      Available = 2
        //      Preparing = 3
        //      Charging = 4
        //      Suspended = 5
        //      Finishing = 6
        //      Reserved = 7
        //      Removed = 99
        // SessionStatus:
        //      Preparing = 0
        //      Charging = 1
        //      Suspended = 2
        //      Finishing = 3
        //      Faulted = 99
      });
    },
    // 获取refreshToken
    getRefreshToken() {
      let refreshToken = localStorage.getItem("refreshToken");
      this.$http.get("/xre/sys/refresh/" + refreshToken).then(res => {
        console.log(res, "获取refreshToken");
        this.refresh.refreshToken = res.refreshToken;
        this.refresh.updateTime = +res.expire + "000";
        this.$store.commit("updateToken", res.token);
        this.$store.commit("updateRefreshToken", this.refresh);
      });
    }
  },
  created() {
    this.getLoginInfo();
  },
  beforeDestroy() {
    this.bannerReloadTimer && clearInterval(this.bannerReloadTimer);
    clearInterval(this.timer);
    clearInterval(this.animateTimer);
    clearInterval(this.getRefreshTokenNum);
    clearInterval(this.getWeatherInterval);
  }
};
</script>

<style lang="scss">
.banner-carousel {
  // width: 60%;
  width: 1152px;
  height: 1080px;
  flex-shrink: 0;
  position: relative;
  .el-carousel__container {
    height: 100%;
  }
  .el-carousel__indicators {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.car-img {
  width: 100%;
  height: 100%;
}
.parking-car-box {
  width: 100%;
}
.parking-car-img {
  width: 200px;
  height: 540px;
}
.weather {
  width: 40px;
  height: 28px;
  margin-top: 12px;
  margin-right: 10px;
}
.carousel-page {
  display: flex;
  justify-content: space-between;
  .charge-show {
    width: 568px;
    margin: 0 auto;
    .SOC {
      height: 335px;
      width: 568px;
      background: url(../assets/img/SOC-background.png) no-repeat;
      background-size: 100% 100%;
      position: relative;
      padding: 0.1rem 0 0;
      .charge-gun-name {
        transform: translate(-50%, -200%);
      }
    }
    .Power-aggregation {
      margin-top: 20px;
      padding-top: 15px;
      width: 567px;
      background: url(../assets/img/power-background.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .point {
    width: 20px;
    height: 20px;
    background-color: #e60000;
    position: relative;
    border-radius: 50%;
  }

  /* 设置动画前颜色 */
  .point-flicker:after {
    background-color: rgba(215, 11, 25, 0.8);
  }

  /* 设置动画后颜色 */
  .point-flicker:before {
    background-color: rgba(215, 11, 25, 0.2);
  }

  /* 设置动画 */
  .point-flicker:before,
  .point-flicker:after {
    content: "";
    width: 60px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -31px;
    margin-top: -31px;
    border-radius: 50%;
    /* CSS3 animation 属性 网址 */
    /* https://www.w3school.com.cn/cssref/pr_animation.asp */
    animation: warn 1.5s ease-out 0s infinite;
  }

  /* @keyframes 规则用于创建动画。在 @keyframes 中规定某项 CSS 样式，就能创建由当前样式逐渐改为新样式的动画效果。 */
  @keyframes warn {
    0% {
      transform: scale(0.5);
      opacity: 1;
    }

    30% {
      opacity: 1;
    }
    100% {
      transform: scale(1.4);
      opacity: 0;
    }
  }
  .parking {
    width: 500px;
    text-align: center;
    position: relative;
    .parking-car {
      margin: 0 auto;
      width: 210px;
      height: 460px;
      background: url(../assets/img/car.png) no-repeat;
      background-size: 100% 100%;
    }
    .charge-point {
      position: absolute;
      top: 180px;
      left: 165px;
    }
  }
  .double-parking {
    width: 500px;
    text-align: center;
    position: relative;
    .parking-car {
      margin: 0 auto;
      width: 210px;
      height: 460px;
      background: url(../assets/img/car.png) no-repeat;
      background-size: 100% 100%;
    }
    .charge-point {
      position: absolute;
      top: 180px;
      left: 165px;
    }
    .other-point {
      position: absolute;
      top: 180px;
      left: 320px;
    }
  }
  .charge-point {
    position: absolute;
    top: 180px;
    left: 165px;
    .point {
      width: 20px;
      height: 20px;
      background-color: #e60000;
      position: relative;
      border-radius: 50%;
    }

    /* 设置动画前颜色 */
    .point-flicker:after {
      background-color: rgba(215, 11, 25, 0.8);
    }

    /* 设置动画后颜色 */
    .point-flicker:before {
      background-color: rgba(215, 11, 25, 0.2);
    }

    /* 设置动画 */
    .point-flicker:before,
    .point-flicker:after {
      content: "";
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -31px;
      margin-top: -31px;
      border-radius: 50%;
      /* CSS3 animation 属性 网址 */
      /* https://www.w3school.com.cn/cssref/pr_animation.asp */
      animation: warn 1.5s ease-out 0s infinite;
    }

    /* @keyframes 规则用于创建动画。在 @keyframes 中规定某项 CSS 样式，就能创建由当前样式逐渐改为新样式的动画效果。 */
    @keyframes warn {
      0% {
        transform: scale(0.5);
        opacity: 1;
      }

      30% {
        opacity: 1;
      }
      100% {
        transform: scale(1.4);
        opacity: 0;
      }
    }
  }
}
.el-progress {
  margin-right: 20px;
  .el-progress-bar {
    width: 360px;
  }
}
.el-progress__text {
  display: inline-block;
  width: 100px;
}
.red {
  .el-progress__text {
    color: rgba(215, 11, 25, 1);
  }
  .el-progress-bar {
    .el-progress-bar__outer {
      background-color: rgba(215, 11, 25, 0.2);
    }
  }
}
.yellow {
  .el-progress__text {
    color: rgba(247, 181, 0, 1);
  }
  .el-progress-bar {
    .el-progress-bar__outer {
      background-color: rgba(247, 181, 0, 0.2);
    }
  }
}
.blue {
  .el-progress__text {
    color: rgba(0, 168, 228, 1);
  }
  .el-progress-bar {
    .el-progress-bar__outer {
      background-color: rgba(0, 168, 228, 0.2);
    }
  }
}
.one-car {
  width: 60px;
  // margin-left: 20px;
  position: relative;
  .car-border {
    height: 40px;
    width: 30px;
    border-right: 2px solid #666666;
  }
  .car-Power {
    height: 90px;
    width: 60px;
    background: url(../assets/img/parking-space.png) no-repeat;
    background-size: 100% 100%;
  }
  .car-num {
    margin-top: 5px;
    color: #999999;
    font-size: 14px;
    position: absolute;
    width: 200px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.red-car {
  position: relative;
  .single-current {
    width: 60px;
    .current-direction {
      width: 8px;
      height: 8px;
      background-color: #e60000;
      border-radius: 50%;
      position: absolute;
      left: 42%;
      // transform: translateX(-128%);
      top: 0px;
    }
    .car-border {
      height: 40px;
      width: 30px;
      border-right: 2px solid #e60000;
    }
    .car-Power {
      height: 90px;
      width: 60px;
      background: url(../assets/img/charging.png) no-repeat;
      background-size: 100% 100%;
    }
    .car-num {
      margin-top: 5px;
      color: #e60000;
      font-size: 14px;
    }
  }
}
.double {
  position: relative;
  .double-current {
    display: flex;
    justify-content: space-around;
    height: 40px;
    div {
      height: 100%;
    }
    .double-left,
    .double-right {
      position: relative;
    }
    .double-current-direction {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #e60000;
      position: absolute;
      top: 0px;
      transform: translateX(-3px);
    }
    .double-car-border {
      height: 100%;
      width: 2px;
      border-right: 2px solid #e60000;
      &.no-charge {
        border-color: #666666;
      }
    }
  }
  .car-Power {
    height: 90px;
    width: 60px;
    background: url(../assets/img/parking-space.png) no-repeat;
    background-size: 100% 100%;
    &.charge {
      background: url(../assets/img/charging.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .car-num {
    margin-top: 5px;
    font-size: 14px;
    position: absolute;
    width: 200px;
    left: 50%;
    transform: translateX(-50%);
    .car-name {
      color: #666;
      &.charge {
        color: #e60000;
      }
    }
  }
}
.progress-color {
  color: #999999;
  font-size: 14px;
}
.el-progress__text {
  margin-left: 40px;
}
.el-progress-bar {
  width: 80%;
}
.progress {
  margin: 5px 70px 0px;
  height: 215px;
  text-align: left;
}
.corner-bottom {
  display: flex;
  justify-content: space-between;
}
.aggregation-title {
  display: flex;
  margin-left: 20px;
}
.corner-top {
  display: flex;
  justify-content: space-between;
}
.soc-center {
  background: url(../assets/img/charge.gif) no-repeat;
  background-size: 100% 100%;
  width: 500px;
  height: 500px;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  margin: auto;
  text-align: center;
  .Power-percentage {
    font-size: 39px;
    color: #111111;
    transform: translateY(480%);
  }
  .Power-num {
    font-size: 20px;
    color: #666666;
    transform: translateY(940%);
  }
  .double-charge {
    color: #666666;
    font-size: 14px;
    transform: translateY(1300%);
  }
}
.soc-title {
  color: #e60000;
  font-weight: 600;
}
.car-logo {
  display: flex;
  margin-left: 20px;
}
.charge-ing {
  margin-top: 20px;
  width: 100%;
  height: 600px;
  .el-carousel__container {
    position: relative;
    height: 564px;
  }
  .car-charge {
    text-align: center;
    .charge-text {
      font-size: 24px;
      line-height: 124px;
    }
  }
  .car-info {
    width: 393px;
    height: 400px;
  }
}
.border-line {
  width: 30px;
  height: 22px;
  border-right: 2px solid #999999;
}
.el-table tr {
  color: rgba(17, 17, 17, 1);
  font-size: 12px !important;
  font-weight: 400;
  th {
    font-size: 12px !important;
  }
}
.logo-img {
  width: 30px;
  height: 15px;
  background: url(../assets/img/title-left.png) no-repeat;
  position: relative;
  top: 8px;
}

.page-index {
  background-color: #ffffff;
  font-size: 20px;
  .container {
    background: url(../assets/img/background.png) no-repeat;
    background-size: 100% 100%;
    width: 40%;
    // flex: 1;
    min-width: 768px;
    .header {
      color: #ffffff;
      .title {
        height: 40px;
        line-height: 40px;
        width: 100%;
        background-color: rgba(215, 11, 25, 1);
        background-size: 100% 100%;
        text-align: center;
        position: relative;
        &-text {
          font-size: 20px;
        }
        img {
          height: 26px;
          right: 0.1rem;
        }
      }
      .info {
        height: 60px;
        width: 693px;
        margin-top: 5px;
        background: url(../assets/img/top-03.png);
        background-size: 100% 100%;
        font-size: 28px;
        text-align: right;
        line-height: 60px;
        font-weight: 300;
        &-temp {
          margin-right: 50px;
        }
        &-weather {
          margin-right: 20px;
        }
        &-time {
          margin-left: 5px;
        }
        &-week {
          margin-left: 30px;
          margin-right: 50px;
        }
      }
    }
    .charge-blank {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 600px;
      .charge-text {
        line-height: 25px;
        font-size: 18px;
        color: #111111;
        font-weight: 600;
      }
      .charge-car {
        margin-top: 10px;
        width: 397px;
        height: 540px;
        background: url(../assets/img/blank.png) no-repeat;
        background-size: 100% 100%;
        .border-top {
          display: flex;
          justify-content: space-between;
          .top-left {
            width: 48px;
            height: 49px;
            border-top: 2px solid #e60000;
            border-left: 2px solid #e60000;
          }
          .top-right {
            width: 48px;
            height: 49px;
            border-top: 2px solid #e60000;
            border-right: 2px solid #e60000;
          }
        }
        .border-car {
          height: 468px;
        }
      }
    }
    .charge-list {
      width: 100%;
      background: url(../assets/img/station-events.png) no-repeat;
      background-size: cover;
      margin-top: 90px;
      padding-top: 15px;
      position: relative;
      overflow: hidden;
      .el-carousel__container {
        height: 600px;
        width: 580px;
      }
      .charge-logo {
        display: flex;
        color: #e60000;
        font-weight: 600;
        margin-left: 25px;
      }
      .event-logo {
        height: 10px;
        width: 500px;
        position: absolute;
        right: 15px;
        top: 20px;
      }
      .charge-table {
        margin-top: 20px;
        margin-left: 20px;
      }
      .charge-bottom {
        display: flex;
        justify-content: space-between;
      }
    }
    .cell {
      text-align: center;
    }
  }
}
</style>
